"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const b_1 = __importDefault(require("b_"));
const tooltip_1 = __importDefault(require("src/components/tooltip"));
const modal_1 = require("src/context/modal");
const b = b_1.default.with('emotion');
const emotionsMap = {
    1: 'angry',
    2: 'sad',
    3: 'neutral',
    4: 'smile',
    5: 'laugh'
};
function QuestionEmotionLabel(props) {
    const { theme, options = [], labels, handleClickOption } = props;
    const context = (0, modal_1.useModalContext)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('options', { theme }) }, { children: options.map(option => {
            const emotion = emotionsMap[option.id];
            let classes = `${b('option', { [emotion]: true })} `;
            if (option.checked) {
                classes += ` checked`;
            }
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('container') }, { children: theme === 'default' && labels ? ((0, jsx_runtime_1.jsxs)(tooltip_1.default, Object.assign({ text: labels[option.id - 1] || '', onlyMobile: true, checked: option.checked, displayOn: context.feedbackDemoMode }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('wrapper', { theme }) }, { children: (0, jsx_runtime_1.jsx)("div", { className: classes, onClick: handleClickOption, "data-value": option.id }) })), !context.feedbackDemoMode && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('label', { overflow: true }) }, { children: labels[option.id - 1] })))] }))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('wrapper', { theme }) }, { children: (0, jsx_runtime_1.jsx)("div", { className: classes, onClick: handleClickOption, "data-value": option.id }) }))) }), option.id));
        }) })));
}
exports.default = QuestionEmotionLabel;
